import NavBarWithFooterLayout from "../../layouts/navBarWithFooter.layout";
import Page from "./page.home.page";

const HomeLayout = () => {
  return (
    <NavBarWithFooterLayout>
      <Page />
    </NavBarWithFooterLayout>
  );
};

export default HomeLayout;
